import React, { Component } from "react";
import * as actions from "../../actions";
import { connect } from "react-redux";
import EkoDataTable from "../../components/elements/EkoDataTable";
import AddItem from "./AddItem";
import HelperContainer from "../../util/HelperContainer";
import Api from "../../util/Api";
import { toastr } from "react-redux-toastr";
import UtilHelper from "../../util/UtilHelper";
import Util from "../../util/Util";
import {Tab, Tabs} from "react-bootstrap";
import Warehouses from "../Warehouses/Warehouses";
import TransferWarehousesList from "../Transfer/TransferWarehousesList";
import ProductPlaningList from "../Plan/ProductPlaningList";
import RecipeList from "../Recipe/RecipeList";
import ItemGroupModal from "../../components/elements/ItemGroupModal";
import EkoModal from "../../components/elements/EkoModal";

class ProductService extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModalGroupModal: false,
      selectedRow: {},
      showUpdateModal: false,
      showInsertModal: false,
      errors: {},
      validationFields: [],
      items: [],
      data: [],
      passiveButton: "Pasifleştir",
      activeButton: "Aktifleştir",
      showChangingModal: false,
      onCancel: false,
      loading: false,
      changingData: {},
      quantity_precision: 2,
      dataLoading: false
    };
  }

  fetchItems() {
    this.setState({ dataLoading: true });
    if (this.table) this.table.cleanSelect();
    Api.get("/item/list", (data, errors) => {
        if (errors) {
            this.setState({ dataLoading: false });
            return;
        }

        if (data.items) {
            // Veriyi mapItems ile formatlıyoruz
            let items = this.mapItems(data.items);

            this.setState({
                items,
                data: items,
                dataLoading: false
            });
        }
    });
}

  componentWillMount() {
    this.getSettingsAndFetchItems();
  }

  onCancel = () => {
    this.setState({ onCancel: true });
  };

  getSettingsAndFetchItems() {
    this.setState({ dataLoading: true });
    Api.get("/getCompanySettings", (response, err) => {
        let precision = 2; // Ayar yoksa default 2
        if (response && response.result && response.result.quantity_decimal_count !== undefined) {
            // DB değeri 5 ise precision 6 olur
            precision = parseInt(response.result.quantity_decimal_count) + 1;
        }
        this.setState({ quantity_precision: precision }, () => {
            this.fetchItems();
        });
    });
}

  mapItems(items) {
    const { quantity_precision } = this.state;

    if (items && Array.isArray(items)) {
        return items.map((item) => {
            let newItem = { ...item };
            if (newItem.quantity !== null && newItem.quantity !== undefined) {
                // 1. Gelen veriyi string (metin) olarak alıyoruz
                let rawVal = String(newItem.quantity);

                // 2. Nokta/Virgül karmaşasını temizliyoruz
                // Eğer API veriyi Türkçe formatta ("2.056,00" veya "2056,50") gönderiyorsa:
                if (rawVal.includes(',')) {
                    // Binlik ayracı olan noktaları tamamen siliyoruz ("2056,00")
                    rawVal = rawVal.replace(/\./g, '');
                    // Ondalık ayracı olan virgülü JS'in anladığı noktaya çeviriyoruz ("2056.00")
                    rawVal = rawVal.replace(',', '.');
                } 
                // Eğer API veriyi sadece binlik noktasıyla "2.056" olarak gönderiyorsa (nadir ama olası):
                else if (rawVal.includes('.') && rawVal.split('.')[1].length === 3) {
                    // Noktayı tamamen siliyoruz ("2056")
                    rawVal = rawVal.replace(/\./g, '');
                }

                // 3. Artık metni güvenli bir şekilde gerçek sayıya (Float) çevirebiliriz
                let numericValue = parseFloat(rawVal);

                // 4. Sayı geçerliyse formata sokuyoruz
                if (!isNaN(numericValue)) {
                    // Util fonksiyonuna kafasını karıştırmayacak tertemiz bir sayı gönderiyoruz
                    newItem.quantity = Util.convertDecimalToString(numericValue, quantity_precision);
                }
            }

            return newItem;
        });
    }
    return [];
  }

  openChangingModal = selectedRow => {
    const self = this;
    console.log("selectedRowID ---> ", selectedRow.id);
    /*     Api.get("/subItem/showAll/" + selectedRow.id, function(res, err) {
          if (res.status === "fail") {
            toastr.warning("Dikkat", res.message);
          } else if (res.status === "ok") {
            self.setState({ changingItems: res.items });
          }
        }); */
    this.setState({ showChangingModal: true, changingData: selectedRow });
  };

  itemTransaction(selectedRow) {
    this.props.router.push("/dashboard/transaction/item/" + selectedRow.id);
  }

  passiveActive(state) {
    const self = this;
    Api.get("/item/" + state.selectedRow.id, function(responses) {
      let formData = {};
      formData.item = HelperContainer.filterObject(responses.item);
      if (responses.item) {
        let toggleName = "";
        if (formData.item.is_active === 1) {
          toggleName = " pasifleştirmek ";
        } else {
          toggleName = " aktifleştirmek ";
        }
        toastr.confirm(
          responses.item.item_name +
            " hesabını" +
            toggleName +
            "istediğinize emin misiniz?",
          {
            onOk: () => {
              let func = "put";
              let url = "/item/" + formData.item.id;

              if (formData.item.is_active === 1) {
                formData.item.is_active = 0;
              } else if (formData.item.is_active === 0) {
                formData.item.is_active = 1;
              }

              Api[func](url, formData.item, function(response, postErrors) {
                if (postErrors) {
                  if (postErrors.message) {
                    toastr.error("Başarısız", postErrors.message);
                  }
                } else {
                  if (formData.item.is_active === 1) {
                    let toggleName = "";
                    if (responses.item.is_active === 1) {
                      toggleName = " pasifleştirildi";
                    } else {
                      toggleName = " aktifleştirildi";
                    }

                    self.fetchItems();
                    toastr.success("Başarılı", "Hesap" + toggleName + "");
                  }
                }
              });
            },
            onCancel: () => {},
            okText: "Evet",
            cancelText: "Hayır"
          }
        );
      }
    });
  }

  openUpdate(selectedRow) {
    var self = this;
    const id = selectedRow.id;
    Api.get("/item/" + id, function(response) {
      let formData = {};
      formData.item = HelperContainer.filterObject(response.item);

      formData.item.purchase_unit_price = UtilHelper.money.convertDecimalToMoney8(
        formData.item.purchase_unit_price
      );
      formData.item.sales_unit_price = UtilHelper.money.convertDecimalToMoney8(
        formData.item.sales_unit_price
      );

      self.setState({
        showInsertModal: true,
        errors: {},
        formData: formData
      });
    });
  }

  changingUpdateShow = () => {
    this.setState({ showModal: false });
  };

  onDelete(selectedRow) {
    const self = this;
    Api.delete("/item/" + selectedRow.id, function(response, err) {
      if (response) {
        self.fetchItems();
        toastr.success("Başarılı", "Başarıyla Silindi");
      } else toastr.error("Hata", err.message);
    });
  }

  onSave(formData, formFields) {
    this.fetchItems();
    this.setState({ showInsertModal: false, formData: false });
  }
  openInsert(menuItem) {
    if (menuItem === 1) {
      this.setState({ showInsertModal: true, formData: false });
    }else if (menuItem === 2) {
      this.props.router.push("/dashboard/BulkStockUpdate");
    }else if (menuItem === 3) {
      this.setState({ showModalGroupModal: true, formData: false });
    }

  }
  render() {
    const hash = window.location.hash;
    var activeTab = "product_list"; // default tab
    if (hash && hash != '') {
      activeTab = hash.replace("#", "");
    }
    const insertMenu = [
      {id: 1, name: 'Ürün Ekle'},
      {id: 2, name: 'Toplu Stok Düzenle'},
      {id: 3, name: 'Ürün Grubu İşlemleri'},
    ];
    return (
        <div>
          <a style={{"bottom": "6px", "position": "relative", "color": "grey"}}
             onClick={Util.backButton.bind(this, "/dashboard")}><i className="fa fa-arrow-left"></i> Geri Dön</a>
          <div className="portlet light">
            <div className="portlet-body">
              <Tabs defaultActiveKey={activeTab} id="uncontrolled-tab-example">
                <Tab eventKey="product_list" title="Ürün Listesi">
                  <div>
                    <AddItem
                        showModal={this.state.showInsertModal}
                        formData={this.state.formData}
                        onSave={this.onSave.bind(this)}
                        onCancel={() => {
                          this.setState({showInsertModal: false});
                        }}
                        errors={this.state.errors}
                    />

                    {/*
                        <AddChangingModal
                            showModal={this.state.showChangingModal}
                            closeModal={() => {
                              this.setState({ showChangingModal: false });
                            }}
                            changingSave={() => {
                              this.setState({ loading: true });
                            }}
                            changingData={this.state.changingData}
                        />
                        */}

                    <EkoDataTable
                        hiddenColumns={[
                          {column_name: "sub_items", isHidden: true, id: "sub_items"}
                        ]}
                        onRef={item => (this.table = item)}
                        passiveActive={this.passiveActive.bind(this)}
                        fetchData={this.fetchItems}
                        openUpdate={this.openUpdate.bind(this)}
                        onDelete={this.onDelete.bind(this)}
                        onFetch={this.fetchItems.bind(this)}
                        itemTransaction={this.itemTransaction.bind(this)}
                        openChangingModal={this.openChangingModal.bind(this)}
                        data={this.state.items}
                        name={"item"}
                        loading={this.state.dataLoading}
                        insertMenu={insertMenu}
                        openInsert={this.openInsert.bind(this)}
                    ></EkoDataTable>
                  </div>
                </Tab>
                {Util.companyModules(2) === true && (
                    <Tab eventKey="warehouses" title="Depolar">
                      <Warehouses/>
                    </Tab>
                )}
                {Util.companyModules(2) === true && (
                    <Tab eventKey="transfer-warehouse" title="Depolar Arası Transfer">
                      <TransferWarehousesList/>
                    </Tab>
                )}
                {Util.companyModules(2) === true && (
                    <Tab eventKey="production-planing" title="Üretim Planlama">
                      <ProductPlaningList/>
                    </Tab>
                )}
                {Util.companyModules(2) === true && (
                    <Tab eventKey="recipe" title="Reçete">
                      <RecipeList/>
                    </Tab>
                )}
              </Tabs>
              <EkoModal
                  bsSize={"large"}
                  dialogClassName={""}
                  showModal={this.state.showModalGroupModal}
                  title="Ürün Grupları"
                  onHide={() => {
                    this.setState({showModalGroupModal: false});
                  }}>
                <ItemGroupModal/>
              </EkoModal>
            </div>
            <br/>
          </div>
        </div>

    );
  }
}


function mapStateToProps(state) {
  return {
    items: state.data.items
  };
}

export default connect(mapStateToProps, actions)(ProductService);